import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
// @ts-ignore
import { UcListPage } from "components/common/UcListPage";
import { useTranslation } from "react-i18next";
// @ts-ignore
import { useSWRConfig } from "swr";
import EnsureUserAndModule from "components/auth/EnsureUserAndModule";
import { mutateUrls } from "lib/useGenericSWR";
import { PageAction, PageContext, PageState } from "lib/PageProvider";
import { UserActivityLogGrid } from "./UserActivityLogGrid";
import { useUserEventLogs } from "./UserEventLogsAPIEndpoints";

export const UserLoginListPage = () => {
    const { t } = useTranslation();
    const [pageState, pageDispatch] = useContext<[PageState, React.Dispatch<PageAction>]>(PageContext);
    const [reMutateUrls, setReMutateUrls] = useState<boolean>(false);
    const swrConfig = useSWRConfig();

    const eventLogFilter = {
        eventType: "Login"
    };

    const swrUserEventLogs = useUserEventLogs(eventLogFilter);

    useEffect(() => {
        pageDispatch({
            header: t("User Logins"),
            actionItems: [] as any[],
            variableHeader: "",
            tabs: [],
            onTabChange: () => { },
            tabValue: "",
        });
    }, [pageState.header, pageDispatch, t]);

    useLayoutEffect(() => {
        if (reMutateUrls) {
            mutateUrls(swrConfig);
            setReMutateUrls(false);
        }
    }, [reMutateUrls, swrConfig]);

    console.log("UserLoginListPage - Loaded");

    return (
        <UcListPage>
            <EnsureUserAndModule permissions={["UserEventLogs:Read"]}>              
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1 className="pageHeader">
                        {t("User Logins")}
                    </h1>                   
                </div>              
                {!reMutateUrls && (
                    <UserActivityLogGrid
                        hideEventTypeColumn={true}
                        swrUserEventLogs={swrUserEventLogs}
                        toolbar={true}
                    />
                )}               
            </EnsureUserAndModule>
        </UcListPage>
    );
};
